import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Producto } from "../../../_models/producto";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavService } from "../../../_services/_nav.service";
import { Location } from "@angular/common";
import { ConfirmationService, SelectItem } from "primeng/api";
import { ProductoDestinoMonto } from "../../../_models/producto-destino-monto";
import { ProductoDestinoMontoService } from "../../../_services/producto-destino-monto.service";
import { forkJoin, Subscription } from "rxjs";
import { ListaService } from "../../../_services/lista.service";
import { ListaItem } from "../../../_models/lista-item";
import { ComunicationComponentsService } from "../../../_services/comunication-components.service";
import { ProductoSubdestinoMontoService } from "../../../_services/producto-subdestino-monto.service";
import { ProductoDestino } from "../../../_models/producto-destino";
import { ProductoSubDestinos } from "../../../_models/producto-subDestinos";
import { ProductosSubDestinosMontos } from "../../../_models/producto-subdestino-monto";
import {ProductosSubdestinosMontosActividadService} from '../../../_services/productos-subdestinos-montos-actividad.service';
import {ProductosSubdestinosMontosActividad} from '../../../_models/productos-subdestinos-montos-actividad';
import {ProductoMontoAliado} from '../../../_models/producto-monto-aliado';
import { ProductosSubdestinosMontosAliadosActividad } from '../../../_models/productos-subdestinos-montos-aliados-actividad';
import { sleep } from '../../../utils/utilidades';
import { Dialog } from 'primeng/dialog';

@Component({
  selector: "app-producto-destino-monto",
  templateUrl: "producto-destino-monto.component.html",
})
export class ProductoDestinoMontoComponent implements OnInit, OnDestroy {
  @Input() producto: Producto;
  @Input() verDetalle: false;
  @ViewChild('dialo') dialogo: Dialog;
  carInformacionInicial = true;
  lisProductosDestinosMontos: ProductoDestinoMonto[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  ranIncorrecto = false;
  ranIncorrectoProducto = false;
  ranIncorrectoPisar = false;
  plaIncorrecto = false;
  plaIncorrectoProducto = false;
  lisDestinos: SelectItem[] = [];
  lisDestinosTodos: ListaItem[] = [];
  private updateSubscription: Subscription;
  lisSubdestino: SelectItem[] = [];
  lisSubdestinoTodos: ListaItem[] = [];
  textoDetalle: string;
  detalle = false;
  tituloDetalle: string;
  listActividadesTodas: ListaItem[] = [];
  listActividades: SelectItem[] = [];
  lisProSubdestinoTodos: ProductosSubDestinosMontos[] = [];
  listProductosSubdestinosMontosActividad: ProductosSubdestinosMontosActividad[] = [];
  formActividades: FormGroup;
  subActividades = false;
  carActividades = false;
  mosActividades = false;
  regSeleccionado: ProductoDestinoMonto;
  lisSubDestinoActividad: SelectItem[] = [];
  colActividades: any[] = [];
  lisActividadesMostrar: ProductosSubdestinosMontosActividad[] = [];
  errorIndicadores = false;

  constructor(
    private proDestinoMontoServicio: ProductoDestinoMontoService,
    private navServicio: NavService,
    private location: Location,
    private fb: FormBuilder,
    private lisServicio: ListaService,
    private conServicio: ConfirmationService,
    private commService: ComunicationComponentsService,
    private proSubdestinoService: ProductoSubdestinoMontoService,
    private productosSubdestinosMontosActividadService: ProductosSubdestinosMontosActividadService,
    private productoSubdestinoMontoService: ProductoSubdestinoMontoService
  ) {}

  ngOnInit(): void {
    this.updateSubscription = this.commService.primerComponent$.subscribe(
      (prodData) => {
        this.producto = prodData;
      }
    );

    this.columnas = [
      {
        field: "nombreDestinoProducto",
        header: this.navServicio.buscarMensaje(
          "PRODUCTODESTINOMONTO.LBL_DESTINO"
        ),
        sort: false,
      },
      {
        field: "subDestino",
        header: this.navServicio.buscarMensaje(
          "PRODUCTODESTINO.LBL_SUBDESTINOS"
        ),
        sort: false,
      },
      {
        field: "rangoMonto",
        header: `${this.navServicio.buscarMensaje(
          "PRODUCTODESTINOMONTO.LBL_RANGOMONTO"
        )} (${this.navServicio.buscarMensaje("LBL_SMLV")})`,
        sort: false,
      },
      {
        field: "rangoPlazo",
        header: `${this.navServicio.buscarMensaje(
          "PRODUCTODESTINOMONTO.LBL_RANGOPLAZO"
        )} (${this.navServicio.buscarMensaje("LBL_MESES")})`,
        sort: false,
      },
      {
        field: "plazoMaximoGarantiaIdonea",
        header: `${this.navServicio.buscarMensaje(
          "PRODUCTOMONTO.LBL_PLAXOMAXIMOGARANTIA"
        )} (${this.navServicio.buscarMensaje("LBL_MESES")})`,
        sort: false,
      },
      {
        field: "indicadorAnalizamos",
        header: `${this.navServicio.buscarMensaje(
          "PRODUCTOMONTO.LBL_INDICADORANALIZAMOS"
        )}`,
        sort: false,
      },
      {
        field: "indicadorFlujoDigital",
        header: `${this.navServicio.buscarMensaje(
          "PRODUCTOMONTO.LBL_INDICADORFLUJODIGITAL"
        )}`,
        sort: false,
      }
    ];
    this.colActividades = [
      { field: 'subDestinoProducto', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_SUBDESTINOS' ), sort: false },
      { field: 'actividadRelacionada', header: this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_ACTIVIDAD' ), sort: false }
    ];

    if (!this.verDetalle) {
      this.columnas.push({
        field: "det",
        header: this.navServicio.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      });
      this.colActividades.push( { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
    }

    forkJoin(
      this.proDestinoMontoServicio.listadoPorProducto(this.producto.idProducto),
      this.lisServicio.getMasterDetails("ListasDestinosProductos"),
      this.lisServicio.getMasterDetails("ListasSubDestinosProductos"),
      this.lisServicio.getMasterDetails('ListasActividadesRelacionadas'),
      this.proSubdestinoService.listadoPorProducto(this.producto.idProducto),
      this.productosSubdestinosMontosActividadService.listaProducto(this.producto.idProducto),
    ).subscribe(
      ([
        lisProductosDestinosMontos,
        lisDestinos,
        subdestino,
         listActividades,
        proSubdestino,
         montosActividad
      ]) => {
        this.lisProductosDestinosMontos = lisProductosDestinosMontos;
        this.lisDestinosTodos = lisDestinos;
        this.lisSubdestinoTodos = subdestino;
        this.lisProSubdestinoTodos = proSubdestino;
        this.listProductosSubdestinosMontosActividad = montosActividad;
        this.listActividadesTodas = listActividades;
        this.cargarFormulario();
        this.validarIndicadores();
        this.cargarFormularioActividades();
        this.cargarListadoDestinos();
        if (this.lisProductosDestinosMontos.length > 0) {
          this.cargarListado();
        } else {
          this.carInformacionInicial = false;
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.updateSubscription) {
      this.updateSubscription.unsubscribe();
    }
  }

  cargarListadoDestinos() {
    this.lisDestinos = this.lisDestinosTodos.map((s) => ({
      label: s.nombre,
      value: s.idLista,
    }));
    this.lisSubdestino = [];
    this.lisSubdestinoTodos.map((s: ListaItem) => {
      this.lisSubdestino.push({ label: s.nombre, value: s.idLista });
    });
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idProductoDestinoMonto: [null],
      idDestinoProducto: [null, [Validators.required]],
      idProducto: [this.producto.idProducto, [Validators.required]],
      montoMinimo: [null, [Validators.required]],
      montoMaximo: [null, [Validators.required]],
      plazoMinimo: [null, [Validators.required]],
      plazoMaximo: [null, [Validators.required]],
      plazoMaximoGarantiaIdonea: [null],
      indicadorHabilitado: [true],
      indicadorGarantiaIdonea: [false],
      indicadorAnalizamos: [false],
      indicadorFlujoDigital: [false],
      auditoriaUsuario: [null],
      auditoriaFecha: [null],
      idSubdestino: [[]]
    });
  }

  validarIndicadores(){
    this.errorIndicadores = !this.f.indicadorAnalizamos.value && !this.f.indicadorFlujoDigital.value;
  }

  get f() {
    return this.formulario.controls;
  }

  inhabilitar(proDestinosMontos: ProductoDestinoMonto) {
    if (
      this.producto.indicadorHabilitado &&
      this.lisProductosDestinosMontos.length === 1
    ) {
      this.navServicio.setMesage(0, {
        severity: "info",
        summary: this.navServicio.buscarMensaje("LBL_INFORMACION"),
        detail: this.navServicio.buscarMensaje("PRODUCTO.MSG_NOINHABILITAR"),
      });
    } else {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje("MSG_INHABILITAR"),
        header: this.navServicio.buscarMensaje("LBL_CONFIRMACION"),
        icon: "fa fa-question-circle",
        key: "destinos-montos",
        accept: () => {
          this.carInformacionInicial = true;
          proDestinosMontos.indicadorHabilitado = false;
          this.proDestinoMontoServicio
            .actualizar(proDestinosMontos)
            .subscribe((regActualizado) => {
              const subDestinoMonto = this.lisProSubdestinoTodos.filter(sud => sud.idProductoDestinoMonto === proDestinosMontos.idProductoDestinoMonto);
              subDestinoMonto.map(l => {
                l.indicadorHabilitado = false;
              });
              this.productoSubdestinoMontoService.bulk(subDestinoMonto).subscribe(subDestinos => {
                const subDestinosMontoActividad = [];
                subDestinos.forEach(s => {
                  const filtroActDes = this.listProductosSubdestinosMontosActividad.filter(act => act.idProductoSubDestinoMonto === s.idProductoSubDestinoMonto);
                  filtroActDes.forEach(f => {
                    f.indicadorHabilitado = false;
                    subDestinosMontoActividad.push(f);
                  });
                });
                this.productosSubdestinosMontosActividadService.bulk(subDestinosMontoActividad).subscribe(actRel => {
                  const a = this.lisProductosDestinosMontos.findIndex(
                    (x) =>
                      x.idProductoDestinoMonto ===
                      proDestinosMontos.idProductoDestinoMonto
                  );
                  if (a >= 0) {
                    this.lisProductosDestinosMontos.splice(a, 1);
                  }
                  this.navServicio.setMesage(2);
                  this.carInformacionInicial = false;
                });
              });
            });
        },
        reject: () => {},
      });
    }
  }

  regresar() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    this.validarRango();
    this.validarPlazo();
    let sudAgregar = [];
    if (
      this.formulario.valid &&
      !this.ranIncorrecto &&
      !this.plaIncorrecto &&
      !this.ranIncorrectoPisar &&
      !this.ranIncorrectoProducto &&
      !this.plaIncorrectoProducto && !this.errorIndicadores
    ) {
      this.guardando = true;
      const proDestinioMonto = this.formulario.value;
      let subDestino = "";
      if (proDestinioMonto.idSubdestino) {
        proDestinioMonto.idSubdestino.map((s) => {
          const d = this.lisSubdestinoTodos.find((x) => x.idLista === s);
          if (subDestino) {
            subDestino = subDestino + ", " + d.nombre;
          } else {
            subDestino = d.nombre;
          }
        });
      }
      this.proDestinoMontoServicio.crear(proDestinioMonto).subscribe(
        (destinoMonto) => {
          proDestinioMonto.idProductoDestinoMonto =
            destinoMonto.idProductoDestinoMonto;
          const b = this.lisDestinosTodos.find(
            (x) => x.idLista === proDestinioMonto.idDestinoProducto
          );
          if (b) {
            proDestinioMonto.nombreDestinoProducto = b.nombre;
          }
          if (subDestino.length > 45) {
            proDestinioMonto.subDestinoCorto = subDestino.substring(0, 45);
            proDestinioMonto.subDestino = subDestino;
            proDestinioMonto.verCompleto = true;
          } else {
            proDestinioMonto.subDestinoCorto = subDestino;
            proDestinioMonto.subDestino = subDestino;
            proDestinioMonto.verCompleto = false;
          }
          this.lisProductosDestinosMontos = [
            ...this.lisProductosDestinosMontos,
            proDestinioMonto,
          ];
          sudAgregar = this.listaSubDestino(destinoMonto);
          if(sudAgregar.length > 0){
            this.proSubdestinoService.bulk(sudAgregar).subscribe(async (sub) => {
              const lisActividadInhabilitar = [];
              sub.map(x => {
                const existe = this.lisProSubdestinoTodos.find( s => s.idProductoSubDestinoMonto === x.idProductoSubDestinoMonto);
                if (!existe) {
                  const item = this.lisSubdestinoTodos.find( y => y.idLista === x.idSubDestinoProducto );
                  x.subDestinoProducto = item ? item.nombre : null;
                  this.lisProSubdestinoTodos.push(x);
                } else {
                  existe.indicadorHabilitado = x.indicadorHabilitado;
                  if ( !existe.indicadorHabilitado ) {
                    this.listProductosSubdestinosMontosActividad.forEach( y => {
                      if ( y.indicadorHabilitado && y.idProductoSubDestinoMonto === existe.idProductoSubDestinoMonto ) {
                        y.indicadorHabilitado = false;
                        lisActividadInhabilitar.push( y );
                      }
                    } );
                  }
                }
              });
              if ( lisActividadInhabilitar.length > 0 ) {
                await this.productosSubdestinosMontosActividadService.bulk( lisActividadInhabilitar ).toPromise();
              }
              this.setInicialRegistro();
            });
          } else {
            this.setInicialRegistro();
          }
        },
        (error) => {
          this.guardando = false;
          this.navServicio.setMesage(3);
        }
      );
    }
  }

  setInicialRegistro() {
    this.f.plazoMaximoGarantiaIdonea.setValidators([]);
    this.cargarFormulario();
    this.f.idProducto.setValue(this.producto.idProducto);
    this.f.indicadorHabilitado.setValue(true);
    this.f.indicadorGarantiaIdonea.setValue(false);
    this.f.indicadorAnalizamos.setValue(false);
    this.f.indicadorFlujoDigital.setValue(false);
    this.validarIndicadores();
    this.submitted = false;
    this.guardando = false;
    this.navServicio.setMesage(1);
  }

  validarRango() {
    const inferior = this.f.montoMinimo.value;
    const superior = this.f.montoMaximo.value;

    const rangoMinimoProducto = this.producto.montoMinimo;
    const rangoMaximoProducto = this.producto.montoMaximo;
    const valMinima = Number(inferior) < Number(rangoMinimoProducto);
    const valMaxima = Number(superior) > Number(rangoMaximoProducto);
    let pisanRangos = false;
    if (
      (inferior || inferior === 0) &&
      (superior || superior === 0) &&
      this.lisProductosDestinosMontos.find(
        (e) =>
          ((Number(inferior) >= Number(e.montoMinimo) &&
            Number(inferior) < Number(e.montoMaximo)) ||
            (Number(superior) >= Number(e.montoMinimo) &&
              Number(superior) < Number(e.montoMaximo))) &&
          this.f.idDestinoProducto.value === e.idDestinoProducto && ((this.f.indicadorAnalizamos.value && e.indicadorAnalizamos) || (this.f.indicadorFlujoDigital.value && e.indicadorFlujoDigital))
      )
    ) {
      pisanRangos = true;
    }

    this.ranIncorrecto =
      (inferior || inferior === 0) &&
      (superior || superior === 0) &&
      Number(inferior) >= Number(superior)
        ? true
        : false;
    this.ranIncorrectoProducto =
      !this.ranIncorrecto &&
      (inferior || inferior === 0) &&
      (superior || superior === 0) &&
      (valMinima || valMaxima)
        ? true
        : false;
    this.ranIncorrectoPisar = !this.ranIncorrectoProducto && !!pisanRangos;
  }

  validarPlazo() {
    const inferior = this.f.plazoMinimo.value;
    const superior = this.f.plazoMaximo.value;

    const plazoMinimoProducto = this.producto.plazoMinimo;
    const plazoMaximoProducto = this.producto.plazoMaximo;
    const valMinima = Number(inferior) < Number(plazoMinimoProducto);
    const valMaxima = Number(superior) > Number(plazoMaximoProducto);
    /*let pisanRangos = false;
    if ( lista ) {
      /!* erificar si los rangos se pisan cuando es lista *!/
      if ( this.lisProductosDestinosMontos.find( ( e ) =>
        ( ( inferior >= e.plazoMinimo &&
          inferior <= e.plazoMaximo ) ||
          ( superior >= e.plazoMinimo &&
            superior <= e.plazoMaximo ) ) &&
        ( item.idPerfilRiesgo === e.idPerfilRiesgo &&
          item.idDestinoProducto === e.idDestinoProducto ) ) ) {
        return true;
      } else {
        return false;
      }
    } else {
      /!* verificar si los rangos se pisan *!/
      if ( this.lisProductosDestinosMontos.find( ( e ) =>
        ( ( inferior >= e.plazoMinimo &&
          inferior <= e.plazoMaximo ) ||
          ( superior >= e.plazoMinimo &&
            superior <= e.plazoMaximo ) ) &&
        ( this.f.idPerfilRiesgo.value === e.idPerfilRiesgo &&
          this.f.idDestinoProducto.value === e.idDestinoProducto ) ) ) {
        pisanRangos = true;
      }
    }*/
    this.plaIncorrecto =
      (inferior || inferior === 0) &&
      (superior || superior === 0) &&
      Number(inferior) >= Number(superior)
        ? true
        : false;
    this.plaIncorrectoProducto =
      !this.plaIncorrecto &&
      (inferior || inferior === 0) &&
      (superior || superior === 0) &&
      (valMinima || valMaxima)
        ? true
        : false;
  }

  listaSubDestino(destino: any) {
    const proDestinoCrear = this.formulario.value;
    let sudAgregar = [];
    proDestinoCrear.idSubdestino.map((sud) => {
      const regAgregar = {
        idProductoDestinoMonto: destino.idProductoDestinoMonto,
        idSubDestinoProducto: sud,
        indicadorHabilitado: true,
      };
      sudAgregar.push(regAgregar);
    });
    return sudAgregar;
  }

  cargarListado() {
    this.lisProductosDestinosMontos.map((s) => {
      if (s.idProductoDestinoMonto) {
        const lisSubDestino = this.lisProSubdestinoTodos.filter(
          (sud) =>
            sud.idProductoDestinoMonto === s.idProductoDestinoMonto &&
            sud.indicadorHabilitado
        );
        let subDestino = "";
        lisSubDestino.map((su) => {
          if (subDestino) {
            subDestino = subDestino + ", " + su.subDestinoProducto;
          } else {
            subDestino = su.subDestinoProducto;
          }
        });
        if (subDestino.length > 45) {
          s.subDestinoCorto = subDestino.substring(0, 45);
          s.subDestino = subDestino;
          s.verCompleto = true;
        } else {
          s.subDestinoCorto = subDestino;
          s.subDestino = subDestino;
          s.verCompleto = false;
        }
      }
      this.carInformacionInicial = false;
    });
  }

  detalleTabla(row: ProductoMontoAliado) {
    this.tituloDetalle = this.navServicio.buscarMensaje(
      "PRODUCTODESTINO.LBL_SUBDESTINOS"
    );
    this.textoDetalle = row.subDestino;
    this.detalle = true;
  }

  detalleTablaAct(row: ProductoMontoAliado) {
    this.tituloDetalle = this.navServicio.buscarMensaje( 'PRODUCTODESTINO.LBL_ACTIVIDAD' );
    this.textoDetalle = row.actividadRelacionada;
    this.detalle = true;
  }

  cambioGarantia( valor: boolean ) {
    this.f.plazoMaximoGarantiaIdonea.setValidators( valor ? [ Validators.required ] : [] );
    this.f.plazoMaximoGarantiaIdonea.setValue( null );
  }

  cargarFormularioActividades() {
    this.formActividades = this.fb.group( {
      idActividadRelacionada: [ [], [ Validators.required ] ],
      idSubdestino: [ null, [ Validators.required ] ]
    } );
  }

  verActividades( row: ProductoDestinoMonto ) {
    this.regSeleccionado = row;
    this.lisSubDestinoActividad = [];
    this.lisProSubdestinoTodos.forEach( e => {
      if ( e.indicadorHabilitado && e.idProductoDestinoMonto === this.regSeleccionado.idProductoDestinoMonto ) {
        this.lisSubDestinoActividad.push( { label: e.subDestinoProducto, value: e.idProductoSubDestinoMonto } );
      }
    } );
    this.cargarActividadesMostrar();
    this.mosActividades = true;
  }

  async guardarActividades() {
    this.subActividades = true;
    if ( !this.formActividades.valid ) {
      return;
    }
    this.carActividades = true;
    const formulario = this.formActividades.value;
    const listadoEnviar = [];
    const itemSubdestino = this.lisSubDestinoActividad.find( x => x.value === formulario.idSubdestino );
    formulario.idActividadRelacionada.forEach( e => {
      const existe = this.listProductosSubdestinosMontosActividad.find( y => y.idProductoSubDestinoMonto === formulario.idSubdestino && y.idActividadRelacionada === e );
      if ( existe && !existe.indicadorHabilitado ) {
        existe.indicadorHabilitado = true;
        listadoEnviar.push( existe );
      } else if ( !existe ) {
        const itemActividad = this.listActividades.find( m => m.value === e );
        const nueRegistro = {} as ProductosSubdestinosMontosActividad;
        nueRegistro.idActividadRelacionada = e;
        nueRegistro.indicadorHabilitado = true;
        nueRegistro.idProductoSubDestinoMonto = formulario.idSubdestino;
        nueRegistro.subDestinoProducto = itemSubdestino ? itemSubdestino.label : null;
        nueRegistro.actividadRelacionada = itemActividad ? itemActividad.label : null;
        listadoEnviar.push( nueRegistro );
      }
    } );
    if ( listadoEnviar.length > 0 ) {
      const actualizado = await this.productosSubdestinosMontosActividadService.bulk( listadoEnviar ).toPromise();
      listadoEnviar.forEach( e => {
        if ( !e.idProductoSubDestinoMontoActividad ) {
          const reg = actualizado.find( m => m.idActividadRelacionada === e.idActividadRelacionada );
          if ( reg ) {
            e.idProductoSubDestinoMontoActividad = reg.idProductoSubDestinoMontoActividad;
            this.listProductosSubdestinosMontosActividad.push( e );
          }
        }
      } );
    }
    this.cargarActividadesMostrar();
    this.navServicio.setMesage( 2 );
    this.reiniciarActividades();
    this.centrarDialogo();
  }

  async centrarDialogo() {
    await sleep( 50 );
    this.dialogo.center();
  }

  cargarActividades( idSubdestino: string ) {
    this.listActividades = [];
    this.listActividadesTodas.forEach( e => {
      if ( !this.listProductosSubdestinosMontosActividad.find( y => y.indicadorHabilitado && y.idProductoSubDestinoMonto === idSubdestino && y.idActividadRelacionada === e.idLista ) ) {
        this.listActividades.push( { label: e.nombre, value: e.idLista } );
      }
    } );

    if ( this.fAct.idActividadRelacionada.value && this.fAct.idActividadRelacionada.value.length > 0 ) {
      const lisAsignar = this.fAct.idActividadRelacionada.value.filter( x => !!this.listActividades.find( y => y.value === x ) );
      this.fAct.idActividadRelacionada.setValue( lisAsignar );
    }
  }

  cargarActividadesMostrar() {
    this.lisActividadesMostrar = this.listProductosSubdestinosMontosActividad.filter( x => x.indicadorHabilitado && !!this.lisSubDestinoActividad.find( m => m.value === x.idProductoSubDestinoMonto ) );
  }

  cerrarModal() {
    this.mosActividades = false;
    this.reiniciarActividades();
    this.regSeleccionado = null;
    this.lisSubDestinoActividad = [];
  }

  reiniciarActividades() {
    this.formActividades.reset();
    this.listActividades = [];
    this.subActividades = false;
    this.carActividades = false;
  }

  get fAct() {
    return this.formActividades.controls;
  }

  inhabilitarActividad( row: ProductosSubdestinosMontosActividad ) {
    this.carActividades = true;
    row.indicadorHabilitado = false;
    this.productosSubdestinosMontosActividadService.actualizarSubDestinosMontosActividad( row ).subscribe( r => {
      this.cargarActividadesMostrar();
      if ( this.fAct.idSubdestino.value ) {
        this.cargarActividades( this.fAct.idSubdestino.value );
      }
      this.navServicio.setMesage( 2 );
      this.carActividades = false;
    } );
  }
}
